import { render, staticRenderFns } from "./couserwareTecDeatil.vue?vue&type=template&id=78d34bab&scoped=true&"
import script from "./couserwareTecDeatil.vue?vue&type=script&lang=js&"
export * from "./couserwareTecDeatil.vue?vue&type=script&lang=js&"
import style0 from "./couserwareTecDeatil.vue?vue&type=style&index=0&id=78d34bab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d34bab",
  null
  
)

export default component.exports